import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Theme } from 'src/app/theme/theme';
import { getAssetUrl } from '../../../shared/asset';
import { AvatarPart } from '../../tribe';

interface BuyingPartsDialogData {
  theme: Theme;
  parts: AvatarPart[];
}

@Component({
  selector: 'app-buying-parts-dialog',
  templateUrl: './buying-parts-dialog.component.html',
  styleUrls: ['./buying-parts-dialog.component.scss'],
  standalone: false
})
export class BuyingPartsDialogComponent {
  data = inject<BuyingPartsDialogData>(MAT_DIALOG_DATA);

  get totalPrice() {
    return this.data.parts.map((part) => part.price).reduce((prev, curr) => prev + curr, 0);
  }

  getPartUrl(part: AvatarPart) {
    return getAssetUrl(part.image.path);
  }
}
